import React, { FC } from "react";
import rightImgPng from "@/images/our-features.png";
import NcImage from "@/shared/NcImage/NcImage";
import Badge from "@/shared/Badge/Badge";

export interface SectionOurFeaturesProps {
  className?: string;
  rightImg?: string;
  type?: "type1" | "type2";
}

export const SectionOurFeatures: FC<SectionOurFeaturesProps> = ({
  className = "",
  rightImg = rightImgPng,
  type = "type1",
}) => {
  return (
    <div
      className={`nc-SectionOurFeatures relative flex flex-col items-center ${
        type === "type1" ? "lg:flex-row" : "lg:flex-row-reverse"
      } ${className}`}
      data-nc-id="SectionOurFeatures"
    >
      <div className="flex-grow hidden lg:block">
        <NcImage src={rightImg} />
      </div>
      <div
        className={`max-w-2xl flex-shrink-0 mt-10 lg:mt-0 lg:w-2/5 ${
          type === "type1" ? "lg:pl-16" : "lg:pr-16"
        }`}
      >
        <span className="uppercase text-sm text-gray-400 tracking-widest">
          Benefits
        </span>
        <h2 className="font-semibold text-4xl mt-5">Gains and merits that can be derived from it.</h2>

        <ul className="space-y-10 mt-16">
          <li className="space-y-4">
            <Badge name="Advertising" />
            <span className="block text-xl font-semibold">
              Effortless Booking
            </span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
            Simplify your advertising journey with our user-friendly platform. Booking a digital billboard is now as easy as 1-2-3. Select your preferred location, upload your design, choose the duration, and voila – your ad is live!
            </span>
          </li>
          <li className="space-y-4">
            <Badge color="green" name="Tracking " />
            <span className="block text-xl font-semibold">
              Real-Time Analytics:
            </span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
            Track campaign performance, gain audience insights, and optimize your strategy with AdBoard Booking's data-driven decision-making.
            </span>
          </li>
          <li className="space-y-4">
            <Badge color="red" name="Exposure" />
            <span className="block text-xl font-semibold">
            Wide Reach
            </span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
            Reach your audience effectively. AdBoard Booking guarantees visibility and impact by connecting your message to prime billboard locations throughout the city
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SectionOurFeatures;
